import { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../config/api";
import { Link } from "react-router-dom";

export const KnowledgeCenter = () => {

    const [knowledgeCenters, setKnowledgeCenters] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

    axios
        .get(`${API_URL}/api/knowledge-centers/all`)
        .then((response) => {

            setKnowledgeCenters(response.data);

        })
        .catch((error) => {

            console.log(error);

        })
        .finally(() => {

            setLoading(false);

        });

    }, []);

    if (loading) {

        return (
            <div className="container py-5 text-center">
                <h4>Loading...</h4>
            </div>
        );
    }

    return (
        <>
                            {/* Page Header */}

            <div className="container-fluid page-header py-5">

                <div className="container text-center py-5">

                    <h1 className="display-4 text-white">
                        Knowledge Center
                    </h1>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb justify-content-center mb-0 animated slideInDown">

                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>

                            <li className="breadcrumb-item">
                                <Link to="/">Pages</Link>
                            </li>

                            <li
                                className="breadcrumb-item text-white"
                                aria-current="page"
                            >
                                Knowledge Center
                            </li>

                        </ol>
                    </nav>

                </div>

            </div>
        <div className="container py-5">

            <div className="text-center mb-5">

                <h5 className="mb-2 px-3 py-1 text-dark rounded-pill d-inline-block border border-2 border-primary">
                    Knowledge Center
                </h5>

                <h1 className="display-5">
                    News, Health Tips & Educational Resources
                </h1>

            </div>

            <div
                className="table-responsive border rounded shadow-sm"
                style={{
                    maxHeight: "600px",
                    overflowY: "auto"
                }}
            >

                <table className="table table-striped table-hover mb-0">

                    <thead
                        className="table-dark"
                        style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 1
                        }}
                    >
                        <tr>
                            <th width="10%">#</th>
                            <th width="55%">Title</th>
                            <th width="20%">Date</th>
                            <th width="15%">Action</th>
                        </tr>
                    </thead>

                    <tbody>

                        {knowledgeCenters.length > 0 ? (

                            knowledgeCenters.map(
                                (item, index) => (

                                    <tr key={item.id}>

                                        <td>
                                            {index + 1}
                                        </td>

                                        <td>
                                            {item.title}
                                        </td>

                                        <td>
                                            {
                                                new Date(
                                                    item.created_at
                                                ).toLocaleDateString(
                                                    "en-US",
                                                    {
                                                        day: "numeric",
                                                        month: "long",
                                                        year: "numeric"
                                                    }
                                                )
                                            }
                                        </td>

                                        <td>

                                            <a
                                                href={item.url}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="btn btn-primary btn-sm"
                                            >
                                                View
                                            </a>

                                        </td>

                                    </tr>

                                )
                            )

                        ) : (

                            <tr>

                                <td
                                    colSpan="4"
                                    className="text-center py-4"
                                >
                                    No records found.
                                </td>

                            </tr>

                        )}

                    </tbody>

                </table>

            </div>

        </div>
        </>

    );

};